import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { useHistoryPushOrInfinityOpen } from 'src/services';

import { QuotaEndedPopup } from './QuotaEndedPopup';

export const QUOTA_ENDED_POPUP = Symbol('QUOTA_ENDED');

const showQuotaEnded = (popups, isFullBlog) =>
  new Promise((resolve) => {
    popups.openPopup(QUOTA_ENDED_POPUP, {
      onClose: (result) => {
        popups.closePopup(QUOTA_ENDED_POPUP);
        resolve(result);
      },
      isFullBlog,
    });
  });

export const useQuotaEndedPopup = () => {
  const popups = usePopups();
  const historyPushOrInfinityOpen = useHistoryPushOrInfinityOpen();

  useEffectOnce(() => {
    popups.registerPopup(QUOTA_ENDED_POPUP, QuotaEndedPopup);
  });

  return useCallback(
    async ({ isFullBlog } = {}) => {
      const result = await showQuotaEnded(popups, isFullBlog);

      if (result?.changeRoute) {
        historyPushOrInfinityOpen(result?.changeRoute);
      }
    },
    [popups, historyPushOrInfinityOpen]
  );
};
